import { render, staticRenderFns } from "./EvolutionPhysicianBar.vue?vue&type=template&id=676eedaf&"
import script from "./EvolutionPhysicianBar.vue?vue&type=script&lang=js&"
export * from "./EvolutionPhysicianBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports